import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

import { TwtOrderType } from '~/tenants/twt/model/enums';

export enum TwtPhotoType {
  INTERIOR_EXTERIOR = 'interior_exterior',
  INTERIOR_ONLY = 'interior',
  EXTERIOR_ONLY = 'exterior_only',
  RESHOOT = 'reshoot',
  RESHOOT_EXTERIOR = 'reshoot_exterior',
}

export default createPerformableConfig(
  'photo',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: z.nativeEnum(TwtPhotoType),
      twilight: coerceBoolean().optional(),
      sunrise: coerceBoolean().optional(),
      license: coerceBoolean().optional(),
      instructions: z.string().optional(),
      libraries: z.string().array().optional(),
      neighborhood: z.string().array().optional(),
      neighborhood_custom: z.object({ location: z.string() }).array().optional(),
      highlights: coerceBoolean().optional(),
      domain: z.string().optional(),
      photos: z.coerce.number().optional(),
      photos_override: z.coerce.number().optional(),
      minutes: z.coerce.number().optional(),
    }),
  },
  {
    name: 'Photo Tour',
    color(metadata) {
      if (metadata.twilight) {
        return '#484CAD';
      }

      if (metadata.type === TwtPhotoType.RESHOOT || metadata.type === TwtPhotoType.RESHOOT_EXTERIOR) {
        return '#75682E';
      }

      return '#D89E43';
    },
    thumbnail(metadata: Record<string, unknown>) {
      if ('type' in metadata && metadata.type === TwtOrderType.COMMERCIAL) {
        return 'tenant/twt/commercial/2.jpg';
      }

      return 'tenant/twt/residential/1.jpg';
    },
    short: 'HDR (High Dynamic Range) photos edited with our advanced digital blending technique.',
    bullets: [
      'Full Screen HD Tour Viewer',
      'Automated Walkthrough Video for YouTube',
      'MLS and Branded Tour Links',
      'Linking, Sharing and Embedding Tools',
      'Customizable Brochures',
    ],
    tenant: TenantId.TWIST_TOURS,
    images: [],
  },
);
